export default "__VITE_ASSET__kYaijP7t__";